const upperGrid = document.querySelector('.upper-grid');
const upperTabs = upperGrid.querySelectorAll('.stage-tab');
const upperMatches = upperGrid.querySelectorAll('.grid-round');

const lowerGrid = document.querySelector('.lower-grid');
const lowerTabs = lowerGrid.querySelectorAll('.stage-tab');
const lowerMatches = lowerGrid.querySelectorAll('.grid-round');

const btnUpper = document.querySelector('.grid-tab-upper-js');
const btnLower = document.querySelector('.grid-tab-lower-js');

upperTabs.forEach(tab => {
    tab.addEventListener('click', e => {
        updateUpper(tab, upperTabs, upperMatches);
    });
});

lowerTabs.forEach(tab => {
    tab.addEventListener('click', e => {
        updateUpper(tab, lowerTabs, lowerMatches);
    });
});

function updateUpper(clickTab, tabs, matchesGrid) {
    tabs.forEach(tab => {
        if (tab == clickTab) {
            tab.classList.add('active');
            matchesGrid.forEach(matches => {
                if (matches.dataset.stage == tab.dataset.stage) {
                    // matches.classList.remove('is-hidden');
                    matches.style.display = 'block';
                } else {
                    // matches.classList.add('is-hidden');
                    matches.style.display = 'none';
                }
            })
        } else {
            tab.classList.remove('active');
        }
    });
}

window.addEventListener('resize',(e) => {
    const width= document.body.clientWidth;
    
    if (width >= 850) {
        upperMatches.forEach(matches => {
            if (!matches.classList.contains('super-final')) {
                matches.style.display = 'block';
            } else {
                matches.style.display = 'none';
            }
        });
        lowerMatches.forEach(matches => {
            matches.style.display = 'block';
        })
    } else if (width >= 601 && width <= 850) {
        upperTabs.forEach(tab => {
            if (tab.classList.contains('active')) {
                upperMatches.forEach(matches => {
                    if (matches.dataset.stage == tab.dataset.stage) {
                        matches.style.display = 'block';
                    } else {
                        matches.style.display = 'none';
                    }
                })
            }
        })

        lowerTabs.forEach(tab => {
            if (tab.classList.contains('active')) {
                lowerMatches.forEach(matches => {
                    if (matches.dataset.stage == tab.dataset.stage) {
                        matches.style.display = 'block';
                    } else {
                        matches.style.display = 'none';
                    }
                })
            }
        })

        upperGrid.style.display = 'block';
        lowerGrid.style.display = 'block';

    } else {
        if (btnUpper.classList.contains('active')) {
            upperGrid.style.display = 'block';
            lowerGrid.style.display = 'none';
        } else {
            upperGrid.style.display = 'none';
            lowerGrid.style.display = 'block';
        }
    }
});

btnUpper.addEventListener('click', () => {
    if (!btnUpper.classList.contains('active')) {
        btnUpper.classList.add('active');
        btnLower.classList.remove('active');
        upperGrid.style.display = 'block';
        lowerGrid.style.display = 'none';
    }
});

btnLower.addEventListener('click', () => {
    if (!btnLower.classList.contains('active')) {
        btnUpper.classList.remove('active');
        btnLower.classList.add('active');
        upperGrid.style.display = 'none';
        lowerGrid.style.display = 'block';
    }
});
